import { useSelector } from "react-redux"
import { RootState } from "../../redux/store"
import { PdfPreviewContent } from "../PdfPreviewContent"
import PdfPreviewHeader from "../PdfPreviewHeader"
import PdfPreviewHeading from "../PdfPreviewHeading"
import PdfPreviewSection from "../PdfPreviewSection"



export const ResetPassword = () => {

    const userData = useSelector((state: RootState) => state.login.userData)
    const resetPasswordData = useSelector((state: RootState) => state.user)

    return (
        <PdfPreviewContent>
            <PdfPreviewHeader
                caption="Documento de reposição de senha do utilizador"
                data={[{ label: "", content: "" }]}
            />
            <PdfPreviewHeading>Credenciais do utilizador</PdfPreviewHeading>
            <PdfPreviewSection title="Informações Confidenciais">
                <p style={{ fontSize: '12px', marginBottom: '10px' }}>
                    Este documento contém informações confidenciais sobre as credenciais de acesso do utilizador.
                    Por favor, mantenha estas informações em segurança.
                </p>
                <div style={{ marginBottom: '10px' }}>
                    <p><strong>Nome de utilizador:</strong> {(resetPasswordData?.userName ?? resetPasswordData?.email) || '[Nome de utilizador]'}</p>
                    <p><strong>Senha:</strong> {resetPasswordData?.password || '[Senha]'}</p>
                </div>
            </PdfPreviewSection>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
                <div style={{ width: '45%', borderTop: '1px solid #333', paddingTop: '10px', textAlign: 'center' }}>
                    <p>Assinatura do utilizador</p>
                    <p>{resetPasswordData?.name}</p>

                </div>
                <div style={{ width: '45%', borderTop: '1px solid #333', paddingTop: '10px', textAlign: 'center' }}>
                    <p>Assinatura de {userData?.Role}</p>
                    <p>{userData?.Fullname}</p>

                </div>
            </div>
        </PdfPreviewContent>
    );
}